import { render, staticRenderFns } from "./ViewPendingChanges.vue?vue&type=template&id=31f401ba"
import script from "./ViewPendingChanges.vue?vue&type=script&lang=js"
export * from "./ViewPendingChanges.vue?vue&type=script&lang=js"
import style0 from "./ViewPendingChanges.vue?vue&type=style&index=0&id=31f401ba&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports